import { Box } from "@mui/material";
import CourseEnrollments from "../../components/CourseEnrollments";

/** Admin → Course Enrollments: every course registration, with payment details. */
const AdminCourseEnrollments = () => (
  <Box sx={{ background: "#f7f9fc", minHeight: "calc(100vh - 70px)", px: { xs: 2, md: 4 }, py: 3 }}>
    <CourseEnrollments mode="admin" dark={false} />
  </Box>
);

export default AdminCourseEnrollments;
